document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-as-rv-section]").forEach((section) => {
    const sectionWrapper = section.closest(".shopify-section");
    if (!sectionWrapper) return;

    const grid = section.querySelector("[data-as-rv-section-grid]");
    const fill = section.querySelector(".as-recently-viewed__scrollbar-fill");
    const scrollbar = section.querySelector(".as-recently-viewed__scrollbar");

    let isDraggingScrollbar = false;
    const currentProductHandleFromLiquid =
      section.dataset.currentProductHandle || null;
    const currentProductHeaderImage = section.dataset.currentHeaderImage || "";

    const currentProductHandleFromUrl = window.location.pathname.includes(
      "/products/",
    )
      ? window.location.pathname.split("/products/")[1].split("/")[0]
      : null;

    const currentProductHandle = (
      currentProductHandleFromLiquid ||
      currentProductHandleFromUrl ||
      ""
    ).trim();

    let isDown = false;
    let isDragging = false;

    let startX = 0;
    let startTranslate = 0;
    let currentX = 0;
    let targetX = 0;
    let maxMove = 0;

    let currentBarX = 0;
    let targetBarX = 0;
    let currentBarWidth = 22;
    let targetBarWidth = 22;

    // Animation loops run only while something is moving (they used to run every frame forever).
    let gridRunning = false;
    let barRunning = false;
    const ensureRunning = () => {
      if (!gridRunning) { gridRunning = true; requestAnimationFrame(animateGrid); }
      if (!barRunning) { barRunning = true; requestAnimationFrame(animateScrollbar); }
    };
    ["pointerdown", "pointermove", "pointerup", "wheel", "touchstart", "touchmove", "keydown", "focusin", "click"].forEach((type) =>
      section.addEventListener(type, ensureRunning, { passive: true, capture: true })
    );
    window.addEventListener("resize", ensureRunning);

    const dragLimit = 6;
    const smoothness = 0.45;
    const scrollbarSmoothness = 0.5;

    function clamp(value) {
      return Math.min(0, Math.max(value, -maxMove));
    }

    function setTarget(value) {
      targetX = clamp(value);
    }

    function updateScrollbar() {
      if (!grid || !fill) return;

      if (maxMove <= 0) {
        targetBarWidth = 100;
        targetBarX = 0;
        return;
      }

      const visibleRatio = grid.parentElement.clientWidth / grid.scrollWidth;
      const fillWidthPercent = Math.max(visibleRatio * 100, 18);
      const progress = Math.abs(currentX) / maxMove;

      const progressWidth = fill.parentElement.offsetWidth;
      const fillWidthPx = (progressWidth * fillWidthPercent) / 100;
      const maxProgressMove = progressWidth - fillWidthPx;

      targetBarWidth = fillWidthPercent;
      targetBarX = progress * maxProgressMove;
    }

    function animateScrollbar() {
      if (fill) {
        currentBarX += (targetBarX - currentBarX) * scrollbarSmoothness;
        currentBarWidth +=
          (targetBarWidth - currentBarWidth) * scrollbarSmoothness;

        if (Math.abs(targetBarX - currentBarX) < 0.1) currentBarX = targetBarX;
        if (Math.abs(targetBarWidth - currentBarWidth) < 0.1)
          currentBarWidth = targetBarWidth;

        fill.style.width = `${currentBarWidth}%`;
        fill.style.transform = `translateX(${currentBarX}px)`;
      }

      if (fill && (currentBarX !== targetBarX || currentBarWidth !== targetBarWidth)) {
        requestAnimationFrame(animateScrollbar);
      } else {
        barRunning = false;
      }
    }

    function animateGrid() {
      if (grid) {
        currentX += (targetX - currentX) * smoothness;

        if (Math.abs(targetX - currentX) < 0.1) {
          currentX = targetX;
        }

        grid.style.transform = `translate3d(${currentX}px, 0, 0)`;
        updateScrollbar();
      }

      if (grid && (currentX !== targetX || isDown || isDragging || isDraggingScrollbar)) {
        requestAnimationFrame(animateGrid);
      } else {
        gridRunning = false;
      }
      if (!barRunning && fill && (currentBarX !== targetBarX || currentBarWidth !== targetBarWidth)) {
        barRunning = true;
        requestAnimationFrame(animateScrollbar);
      }
    }

    function calculateSizes() {
      if (!grid) return;

      maxMove = Math.max(0, grid.scrollWidth - grid.parentElement.clientWidth);
      currentX = clamp(currentX);
      targetX = clamp(targetX);
      updateScrollbar();
    }

    function getRecentlyViewedProducts() {
      try {
        return JSON.parse(
          localStorage.getItem("recently-viewed-products") || "[]",
        );
      } catch (e) {
        return [];
      }
    }

    function formatMoney(cents) {
      if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
        return Shopify.formatMoney(
          cents,
          window.theme?.moneyFormat ||
            window.MinimogSettings?.money_format ||
            "${{amount}}",
        );
      }

      return `$${(cents / 100).toFixed(2)}`;
    }

    function normalizeHandle(handle) {
      return String(handle || "")
        .split("?")[0]
        .split("#")[0]
        .replace("/products/", "")
        .split("/")[0]
        .trim();
    }
    function saveCurrentProductData() {
      const handle = normalizeHandle(currentProductHandle);

      if (!handle) return;

      const viewedItems = getRecentlyViewedProducts();

      const existingIndex = viewedItems.findIndex((item) => {
        const itemHandle = normalizeHandle(
          typeof item === "string" ? item : item.handle,
        );

        return itemHandle === handle;
      });

      let existingItem = {};

      if (existingIndex !== -1) {
        const currentItem = viewedItems[existingIndex];

        existingItem =
          typeof currentItem === "string"
            ? { handle: currentItem }
            : currentItem;

        viewedItems.splice(existingIndex, 1);
      }
      viewedItems.unshift({
        ...existingItem,
        handle,
        header_image:
          currentProductHeaderImage || existingItem.header_image || "",
      });

      try {
        localStorage.setItem(
          "recently-viewed-products",
          JSON.stringify(viewedItems),
        );
      } catch (error) {
        console.error("Unable to save recently viewed product:", error);
      }
    }

    function disableNativeDrag() {
      if (!grid) return;

      grid.querySelectorAll("a, img").forEach((el) => {
        el.setAttribute("draggable", "false");
      });
    }

    async function renderRecentlyViewed() {
      if (!grid) return;

      section.hidden = true;
      grid.innerHTML = "";

      const viewedItems = getRecentlyViewedProducts();
      const currentHandle = normalizeHandle(currentProductHandle);

      const handles = viewedItems
        .map((item) => (typeof item === "string" ? item : item.handle))
        .map(normalizeHandle)
        .filter(Boolean)
        .filter((handle, index, arr) => arr.indexOf(handle) === index)
        .filter((handle) => handle !== currentHandle);

      if (!handles.length) return;

      const products = await Promise.all(
        handles.map(async (handle) => {
          try {
            const res = await fetch(`/products/${handle}.js`);
            if (!res.ok) return null;
            return await res.json();
          } catch (e) {
            return null;
          }
        }),
      );

      const validProducts = products.filter((product) => {
        if (!product) return false;

        const image =
          product.images && product.images.length
            ? product.images[product.images.length - 1]
            : product.featured_image || "";

        const variant =
          product.variants && product.variants.length
            ? product.variants[0]
            : null;
        const priceValue = variant ? variant.price : product.price;

        return image && variant && priceValue;
      });

      if (!validProducts.length) {
        sectionWrapper?.remove();
        return;
      }

      grid.innerHTML = validProducts
        .map((product) => {
          const savedItem = viewedItems.find((item) => {
            const itemHandle = normalizeHandle(
              typeof item === "string" ? item : item.handle,
            );
            return itemHandle === product.handle;
          });

          const reviews = Number(savedItem?.reviews || 0);

          const headerImage = savedItem?.header_image || "";

          const fallbackImage =
            product.featured_image ||
            (product.images && product.images.length ? product.images[0] : "");

          const image = headerImage || fallbackImage;

          const variant =
            product.variants && product.variants.length
              ? product.variants[0]
              : null;

          const priceValue = variant ? variant.price : product.price;
          const compareValue = variant
            ? variant.compare_at_price
            : product.compare_at_price;

          const price = formatMoney(priceValue);

          const comparePrice =
            compareValue && compareValue > priceValue
              ? formatMoney(compareValue)
              : "";

          const savePercent =
            compareValue && compareValue > priceValue
              ? Math.round(((compareValue - priceValue) / compareValue) * 100)
              : 0;

          return `
            <div class="as-recently-viewed__item">
              <a
                href="/products/${product.handle}"
                class="as-recently-viewed__image"
                aria-label="View product: ${product.title}"
              >
                ${image ? `<img src="${image}" alt="" aria-hidden="true" loading="lazy">` : ""}
              </a>
<div class="as-recently-viewed__rating">
  ${
    reviews
      ? `
        <span class="as-recently-viewed__stars">★★★★★</span>
        <span class="as-recently-viewed__reviews">${reviews} Reviews</span>
      `
      : ""
  }
</div>

              <a href="/products/${product.handle}" class="as-recently-viewed__title">
                ${product.title}
              </a>

              <div class="as-recently-viewed__price-row">
                ${
                  variant
                    ? `
                      <button
                        type="button"
                        class="as-recently-viewed__cart"
                        data-variant-id="${variant.id}"
                        aria-label="Add to cart"
                      >
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.04074 2.04074H11.2852L10.1296 7.04815H3.1963M10.1296 8.58889H3.58148L1.65556 0.5H0.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M9.36021 10.9C9.78568 10.9 10.1306 10.5551 10.1306 10.1296C10.1306 9.70416 9.78568 9.35925 9.36021 9.35925C8.93475 9.35925 8.58984 9.70416 8.58984 10.1296C8.58984 10.5551 8.93475 10.9 9.36021 10.9Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M4.3524 10.9C4.77787 10.9 5.12277 10.5551 5.12277 10.1296C5.12277 9.70416 4.77787 9.35925 4.3524 9.35925C3.92694 9.35925 3.58203 9.70416 3.58203 10.1296C3.58203 10.5551 3.92694 10.9 4.3524 10.9Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>

                      </button>
                    `
                    : ""
                }

                <span class="as-recently-viewed__price">${price}</span>
                ${comparePrice ? `<span class="as-recently-viewed__compare">${comparePrice}</span>` : ""}
              </div>

              ${savePercent > 0 ? `<div class="as-recently-viewed__badge">SAVE ${savePercent}%</div>` : ""}
            </div>
          `;
        })
        .join("");

      if (grid.innerHTML.trim() === "") {
        sectionWrapper?.remove();
        return;
      }

      disableNativeDrag();

      section.hidden = false;
      sectionWrapper?.classList.add("as-rv-is-visible");

      currentX = 0;
      targetX = 0;

      requestAnimationFrame(calculateSizes);
    }

    let clickedLink = null;

    grid?.addEventListener("pointerdown", (e) => {
      if (e.button !== undefined && e.button !== 0) return;

      clickedLink = e.target.closest(
        ".as-recently-viewed__image, .as-recently-viewed__title",
      );

      if (e.target.closest(".as-recently-viewed__cart")) {
        return;
      }

      isDown = true;
      isDragging = false;

      startX = e.clientX;
      startTranslate = targetX;

      grid.classList.add("is-dragging");
      grid.setPointerCapture(e.pointerId);
    });

    grid?.addEventListener("pointermove", (e) => {
      if (!isDown) return;

      const diff = e.clientX - startX;

      if (Math.abs(diff) > dragLimit) {
        isDragging = true;
      }

      if (isDragging) {
        e.preventDefault();
        setTarget(startTranslate + diff);
      }
    });

    grid?.addEventListener("pointerup", () => {
      const wasDragging = isDragging;
      const link = clickedLink;

      isDown = false;
      isDragging = false;
      clickedLink = null;

      grid.classList.remove("is-dragging");

      if (!wasDragging && link && link.href) {
        window.location.href = link.href;
      }
    });

    grid?.addEventListener("pointercancel", () => {
      isDown = false;
      isDragging = false;
      clickedLink = null;
      grid.classList.remove("is-dragging");
    });

    grid?.addEventListener(
      "click",
      (e) => {
        if (
          e.target.closest(
            ".as-recently-viewed__image, .as-recently-viewed__title",
          )
        ) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }

        if (isDragging) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true,
    );
    if (scrollbar && fill) {
      fill.addEventListener("pointerdown", (e) => {
        isDraggingScrollbar = true;

        fill.classList.add("is-dragging");
        fill.setPointerCapture(e.pointerId);

        e.stopPropagation();
      });

      fill.addEventListener("pointermove", (e) => {
        if (!isDraggingScrollbar) return;

        const rect = scrollbar.getBoundingClientRect();

        const percent = Math.min(
          1,
          Math.max(0, (e.clientX - rect.left) / rect.width),
        );

        targetX = -(maxMove * percent);
        currentX = targetX;
        grid.style.transform = `translate3d(${currentX}px, 0, 0)`;
        updateScrollbar();

        currentBarX = targetBarX;
        fill.style.transform = `translateX(${currentBarX}px)`;
      });

      fill.addEventListener("pointerup", () => {
        isDraggingScrollbar = false;
        fill.classList.remove("is-dragging");

        currentX = targetX;
        currentBarX = targetBarX;

        grid.style.transform = `translate3d(${currentX}px, 0, 0)`;
        fill.style.transform = `translateX(${currentBarX}px)`;
      });

      scrollbar.addEventListener("click", (e) => {
        if (e.target === fill) return;

        const rect = scrollbar.getBoundingClientRect();

        const percent = Math.min(
          1,
          Math.max(0, (e.clientX - rect.left) / rect.width),
        );

        targetX = -(maxMove * percent);
      });
    }

    window.addEventListener("resize", calculateSizes);

    document.addEventListener("click", async (event) => {
      const btn = event.target.closest(".as-recently-viewed__cart");
      if (!btn || !section.contains(btn)) return;

      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.disabled = true;

      try {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
          }),
        });

        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.dispatchEvent(new CustomEvent("cart:opened"));
      } catch (e) {
        console.error("Recently viewed add to cart error:", e);
      } finally {
        btn.disabled = false;
      }
    });
    grid?.addEventListener("focusin", function (event) {
      const item = event.target.closest(".as-recently-viewed__item");
      if (!item) return;

      const wrapperWidth = grid.parentElement.clientWidth;
      const itemLeft = item.offsetLeft;
      const itemRight = itemLeft + item.offsetWidth;

      const visibleLeft = Math.abs(targetX);
      const visibleRight = visibleLeft + wrapperWidth;

      if (itemLeft < visibleLeft) {
        targetX = -itemLeft;
      } else if (itemRight > visibleRight) {
        targetX = -(itemRight - wrapperWidth);
      }

      targetX = clamp(targetX);
      currentX = targetX;

      grid.style.transform = `translate3d(${currentX}px, 0, 0)`;

      updateScrollbar();

      currentBarX = targetBarX;
      currentBarWidth = targetBarWidth;

      if (fill) {
        fill.style.width = `${currentBarWidth}%`;
        fill.style.transform = `translateX(${currentBarX}px)`;
      }
    });

    ensureRunning();
    function initRecentlyViewedSection() {
      saveCurrentProductData();
      renderRecentlyViewed();
    }

    setTimeout(initRecentlyViewedSection, 800);
  });
});
